webpackJsonp([70144966829960],{

/***/ 63:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(61);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "div",
	        { className: "contact-card" },
	        _react2.default.createElement(
	            "h1",
	            { style: { color: 'white' } },
	            "Reservieren"
	        ),
	        _react2.default.createElement(
	            "p",
	            { style: {
	                    color: 'white'
	                } },
	            "Im einzigartigen Ambiente bieten wir auch R\xE4ume f\xFCr Ihr Feier, Event oder Veranstaltung mit bis zu 140 Personen. Mit Bar und B\xFChnenbereich im hinteren Saal f\xFCr grosse Anl\xE4sse.            ",
	            _react2.default.createElement(
	                "a",
	                { style: { color: 'white' }, href: "https://www.opentable.de/r/vietpho-cuisine-reservations-frankfurt-am-main?restref=166788&lang=de-DE" },
	                "\xDCber Opentable reservieren"
	            ),
	            "\xA0 oder per E-Mail:                    "
	        ),
	        _react2.default.createElement(
	            "article",
	            { id: "contact", className: "active" },
	            _react2.default.createElement(
	                "form",
	                { method: "post", action: "https://formspree.io/hallo@vietphocuisine.de", target: "_blank" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "field half first" },
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "name" },
	                        "Name"
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "name", id: "name" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "field half" },
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "email" },
	                        "E-Mail Addresse"
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "_replyto", id: "email" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "field" },
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "message" },
	                        "Nachricht"
	                    ),
	                    _react2.default.createElement("textarea", { name: "message", id: "message", rows: "4" })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement("input", { type: "submit", value: "Abschicken", className: "special" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { id: "reset" },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: "/" },
	                            _react2.default.createElement("input", { type: "reset", value: "Zur\xFCck" })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "icons" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { style: { color: 'white' }, href: "https://www.facebook.com/VietPho-Cuisine-334073757070790/", className: "icon fa-facebook" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Facebook"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { style: { color: 'white' }, href: "https://www.instagram.com/vietpho_cuisine/", className: "icon fa-instagram" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Instagram"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-4a4faa8e533af7cb4db3.js